import { render, staticRenderFns } from "./FailuresSettings.vue?vue&type=template&id=249597c8&"
import script from "./FailuresSettings.vue?vue&type=script&lang=js&"
export * from "./FailuresSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports